import MenuComponent from "../Menu";

export default function Banner() {
    return (
        <div className="container-text-to-image position-relative">
            <img
                src={`${process.env.PUBLIC_URL}/assets/bg/DJI_0027.jpg`}
                alt="DJI_0027"
                style={{ width: "100%", height: 350, objectFit: "cover", objectPosition: "center" }}
            />

            <div className="position-absolute w-100 h-100 top-0 left-0">
                <div className="container d-flex flex-column justify-content-center align-items-center">
                    <div className="mt-5">
                        <img src={`${process.env.PUBLIC_URL}/assets/cover/S__68960261.jpg`} alt="S__68960261" style={{ width: 150, borderRadius: 10 }} />
                    </div>
                    <div className="h1 fw-bold mt-2" style={{ textShadow: "0 0 10px #000000" }}>
                        R-DNAM: Rice DNA Marker Database
                    </div>
                    <div className="h3 fw-bold" style={{ textShadow: "0 0 10px #000000" }}>
                        ฐานข้อมูลเครื่องหมายดีเอ็นเอข้าว
                    </div>
                </div>
            </div>

            <div className="position-absolute w-100 bottom-0 left-0">
                <div className="container d-flex justify-content-center align-items-center">
                    <MenuComponent />
                </div>
            </div>
        </div>
    );
}
